<template>
  <a-modal
    :width="800"
    title="修改模板"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" @submit="handleSubmit">
      <a-form-item label="评论内容">
        <a-textarea
          :autoSize="{ minRows: 3 }"
          placeholder="评论内容"
          v-decorator="['comment_text', { rules: [{ required: true, message: '必填项' }] }]"
        />
        <emoji-dialog @cencel="copyEmoji" />
        <a-tag @click="copyText(item)" v-for="(item, index) in nods" v-bind:key="index">
          {{ item }}
        </a-tag>
      </a-form-item>
      <a-form-item label="标题">
        <a-input v-decorator="['comment_title', { rules: [{ required: true, message: '必填项' }] }]" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { editMessage } from '@/api/pyq'
import EmojiDialog from '../components/EmojiDialog'
const nods = ['[淘口令]', '[京东短链接]', '[拼多多短链接]', '[原价]', '[券后价]', '[券面值]', '[商品标题]', '[中间页]']
export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      visible: false,
      confirmLoading: false,
      nods,
      info: null
    }
  },
  components: {
    EmojiDialog
  },
  // mounted () {
  //   this.form.setFieldsValue({
  //     comment_text: this.info.comment_text,
  //     comment_title: this.info.comment_title
  //   })
  // },
  methods: {
    show(record) {
      this.visible = true
      this.info = record
      setTimeout(() => {
        this.form.setFieldsValue({
          comment_text: record.comment_text,
          comment_title: record.comment_title
        })
      }, 300)
    },
    copyText(emoji) {
      this.$copyText(emoji)
      this.$message.success('表情复制成功')
    },
    copyEmoji(emoji) {
      this.$copyText(emoji)
      this.$message.success('表情复制成功')
    },
    handleSelectSub() {
      this.$refs.robot.show()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          editMessage({
            comment_title: values.comment_title,
            comment_text: values.comment_text,
            id: this.info.id
          }).then(res => {
            this.visible = false
            this.form.resetFields()
            this.$emit('ok')
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleOk(record) {
      this.form.setFieldsValue({
        robot_id: record.id,
        servant_id: record.servant_id
      })
    }
  }
}
</script>
